/* External */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/* Components */
import AgeRating from '../../components/ageRating/AgeRating';

/* Styles */
import './Metadata.scss';

function Metadata({
  rating,
  metadataValues,
  showRating = false,
}) {
  return (
    <>
      {rating && <AgeRating rating={rating} />}
      <ul className={classNames('dtv-metadata-list', {
        'dtv-metadata-list-duration': !showRating,
      })}
      >
        {[...metadataValues].map((metadataValue, index) => {
          if (!metadataValue) return null;

          return (
            <Fragment key={metadataValue}>
              <li>{metadataValue}</li>
              {index !== [...metadataValues].length - 1 && <li>•</li>}
            </Fragment>
          );
        })}
      </ul>
    </>
  );
}

Metadata.propTypes = {
  rating: PropTypes.string,
  metadataValues: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
  showRating: PropTypes.bool,
};

Metadata.defaultProps = {
  rating: '',
  metadataValues: [],
  showRating: false,
};

export default Metadata;
